<template>
  <div>
    <Head title="Unidades de Medida" />
    <h1 class="mb-8 text-3xl font-bold">Unidades de Medida</h1>
    <div class="flex items-center justify-between mb-6">
      <search v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">        
      </search>
      <Link class="btn-sky" href="/settings/products/units/create">
        <span>Crear</span>
        <span class="hidden md:inline">&nbsp;Unidad</span>
      </Link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-2">Código</th>
          <th class="pb-4 pt-6 px-2">Descripción</th>
          <th class="pb-4 pt-6 px-2">Usuario</th>
          <th class="pb-4 pt-6 px-2">Fecha de creación</th>
        </tr>
        <tr v-for="unit in productsUnits.data" :key="unit.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/settings/products/units/${unit.id}/edit`">{{ unit.codigo }}</Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/settings/products/units/${unit.id}/edit`">{{ unit.descripcion }}</Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/settings/products/units/${unit.id}/edit`">{{ unit.user }}</Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/settings/products/units/${unit.id}/edit`">{{ unit.fecha }}</Link>
          </td>
          <td class="w-px border-t">
            <Link class="flex items-center px-6 py-4" :href="`/settings/products/units/${unit.id}/edit`" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </Link>
          </td>
        </tr>
        <tr v-if="productsUnits.data.length === 0">
          <td class="px-6 py-4 border-t" colspan="4">No se encontraron unidades de medida.</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="productsUnits.links" />
  </div>
</template>
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import mapValues from 'lodash/mapValues'
import throttle from 'lodash/throttle'
import pickBy from 'lodash/pickBy'
import SearchFilter from '@/Shared/SearchFilter'
import Search from '@/Shared/Search'
import Pagination from '@/Shared/Pagination'
import Icon from '@/Shared/Icon'
    
export default {
  components: {
    Head,
    Link,
    Search,
    Pagination,
    Icon,
  },
  layout: Layout,
  props: {
    filters: Object,
    productsUnits: Object,
    codes: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        code: this.filters.code,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/settings/products/units', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  }, 
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>